async function reloadAllCartCounts() {
  const cartCountElements = document.querySelectorAll(".cart-count");
  const cartCountWithDividerElements = document.querySelectorAll(
    ".cart-count-with-divider",
  );

  const res = await fetch("/cart.js");
  const cart = await res.json();
  const newCount = cart.item_count;

  cartCountElements.forEach((element) => {
    element.textContent = newCount;
  });

  cartCountWithDividerElements.forEach((element) => {
    if (newCount > 0) {
      element.textContent = `| ${newCount}`;
    } else {
      element.textContent = "";
    }
  });
}
